/* ============================================
   Music Hub — Headphones.com
   Dark mode toggle, streaming tabs,
   community email signup
   ============================================ */

/* ---- Dark Mode Toggle ---- */
class MusicDarkToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.toggle.bind(this));
  }

  toggle() {
    const isDark = document.body.classList.toggle('music-dark-mode');
    try {
      localStorage.setItem('music-dark-mode', isDark ? 'on' : 'off');
    } catch (e) { /* localStorage unavailable */ }
    this.button.setAttribute('aria-pressed', isDark);
  }
}
customElements.define('music-dark-toggle', MusicDarkToggle);

/* Apply saved dark mode preference before paint */
(function () {
  try {
    if (localStorage.getItem('music-dark-mode') === 'on') {
      document.body.classList.add('music-dark-mode');
    }
  } catch (e) { /* localStorage unavailable */ }
})();

/* ---- Streaming Tabs ---- */
class MusicStreamingTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[data-music-tab]');
    this.panels = this.querySelectorAll('[data-music-panel]');
    if (!this.tabs.length) return;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', this.switchTab.bind(this, tab));
    }.bind(this));

    /* Restore saved preference */
    try {
      var saved = localStorage.getItem('music-streaming-pref');
      if (saved) {
        var savedTab = this.querySelector('[data-music-tab="' + saved + '"]');
        if (savedTab) {
          this.switchTab(savedTab);
          return;
        }
      }
    } catch (e) { /* localStorage unavailable */ }

    /* Activate first available tab */
    var firstEnabled = this.querySelector('[data-music-tab]:not([data-empty="true"])');
    if (firstEnabled) this.switchTab(firstEnabled);
  }

  switchTab(activeTab) {
    var service = activeTab.getAttribute('data-music-tab');

    this.tabs.forEach(function (tab) {
      var isActive = tab === activeTab;
      tab.classList.toggle('music-streaming__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    this.panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-music-panel') === service;
      panel.classList.toggle('music-streaming__panel--active', isActive);

      /* Lazy-load iframe: move data-src to src on first activate */
      if (isActive) {
        var iframe = panel.querySelector('iframe[data-src]');
        if (iframe) {
          iframe.src = iframe.getAttribute('data-src');
          iframe.removeAttribute('data-src');
        }
      }
    });

    try {
      localStorage.setItem('music-streaming-pref', service);
    } catch (e) { /* localStorage unavailable */ }
  }
}
customElements.define('music-streaming-tabs', MusicStreamingTabs);

/* ---- Community Email Signup ---- */
class MusicEmailSignup extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.success = this.querySelector('[data-signup-success]');
    this.submitBtn = this.querySelector('button[type="submit"]');
    if (!this.form) return;

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  handleSubmit(e) {
    e.preventDefault();
    var email = this.input ? this.input.value.trim() : '';
    if (!email) return;

    /* Use Klaviyo JS API if available, otherwise fall back to form action */
    if (window._learnq) {
      window._learnq.push(['identify', {
        '$email': email,
        'Music Community Interest': true
      }]);
    }

    /* Also submit the form natively as a Shopify contact form
       for Klaviyo's Shopify integration to pick up */
    var formData = new FormData(this.form);

    fetch(this.form.action, {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    }).catch(function () { /* Silent fail — Klaviyo identify already ran */ });

    /* Show success state */
    if (this.success) {
      this.success.classList.add('music-community__signup-success--visible');
    }
    if (this.submitBtn) {
      this.submitBtn.textContent = 'Signed up!';
      this.submitBtn.disabled = true;
    }
    if (this.input) {
      this.input.disabled = true;
    }
  }
}
customElements.define('music-email-signup', MusicEmailSignup);
